/*
** $Id$
**
** Copyright 2019 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import PropTypes from 'prop-types';


/**
 * Command help.
 */
export default class CommandHelp extends Component {
    /**
     * Command name and its help to display. 
     *
     * This should be in the format:
     *      { name: <name of the command>, help: <pre-formatted help for the command> }
     */
    static propTypes = {
        command: PropTypes.object.isRequired
    };


    render() {
        return (
            <div>
                <div className='commandHelpHeader'>
                    Syntax
                </div>
                <div className='commandHelpName'>
                    {this.props.command.name}
                </div>
                <pre className='commandHelpOutput'>
                    {this.props.command.help}
                </pre>
            </div>
        );
    }
}
